import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const GeneralChartsContent = ({ data }) => {

    const charts = [
        {
            id: 'quantity-by-type',
            title: 'Quantidade por tipo de combustível',
            data: data?.getGasTypes,
            exportTitle: 'Quantidade por combustível',
            formatter: (value) => value.fuel_type
        },
        {
            id: 'value-by-type',
            title: 'Valor por tipo de combustível',
            data: data?.getGasPayments,
            exportTitle: 'Valor por combustível',
            formatter: (value) => value.fuel_type
        },
        {
            id: 'value-by-gas-station',
            title: 'Valor por posto de combustível',
            data: data?.getGasStationPayments,
            exportTitle: 'Valor por posto',
            formatter: (value) => value.fuel_type
        }
    ];

    useEffect(() => {

        charts.forEach(chart => {

            if (!chart.data) return;

            const labels = [];
            const values = [];
            const valuesMask = [];

            chart.data.forEach(element => {
                labels.push(chart.formatter(element));

                const original = element.qty;
                valuesMask.push(original);

                const valueOnly = original.replace('R$', '').split(' (')[0].trim();
                values.push(parseFloat(valueOnly));
            });

            GraphicUtils.barChart(chart.id, values, labels, false, true, valuesMask);
            labels.length > 0 && ReportUtils.createExportableTable(labels, valuesMask, chart.exportTitle);

        });

    }, [data]);

    const renderedCharts = [];

    for (let index = 0; index < charts.length; index++) {
        const currentChart = charts[index];

        renderedCharts.push(
            <React.Fragment key={currentChart.id}>

                <div className="chart-report">
                    <span className="chart-title"> {currentChart.title}</span>
                    <div className="mt-3" id={currentChart.id}></div>
                </div>

                { index !== charts.length - 1 &&
                    <div className="chart-divisor print:hidden"/>
                }

            </React.Fragment>
        );
    }

    return (
        <>
            <div id="general">

                <div className="report-divisor mb-6">
                    <span className="divisor-title">
                        VISÃO GERAL
                    </span>
                </div>

                {renderedCharts}

            </div>
        </>
    );
};

export default GeneralChartsContent;